var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":""},on:{"click":_vm.openFile}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.metadata.originalFileName)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }